"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldProps = exports.getFileProps = exports.getPasswordComponentProps = exports.getSingleLineStringProps = exports.getBoolComponentProps = exports.getListProps = exports.getPrettySelectProps = void 0;
const design_system_1 = require("@zapier/design-system");
const MappableField_1 = __importDefault(require("../MappableField"));
const CopyField_1 = __importDefault(require("../CopyField"));
const CopyToClipboardInput_1 = __importDefault(require("../CopyToClipboardInput"));
const CheckboxField_1 = __importDefault(require("../CheckboxField"));
const utils_1 = require("../../utils");
const Code_1 = __importDefault(require("../Code"));
const Fields_1 = __importDefault(require("../Fields"));
const PrettySelect_1 = require("../PrettySelect");
const PasswordField_1 = __importDefault(require("../PasswordField"));
const DictionaryField_1 = __importDefault(require("../DictionaryField"));
const ListField_1 = __importDefault(require("../ListField"));
const getPropsByField_1 = __importDefault(require("./getPropsByField"));
const FilterField_1 = __importDefault(require("../FilterField"));
function isFieldFormatterTransform(field) {
    return (field.key === 'transform' &&
        field.prefill &&
        field.prefill.includes('get_transforms'));
}
exports.getPrettySelectProps = (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { isMulti: false, items: props.field.options, shouldShowCustomTab: !isFieldFormatterTransform(props.field) }));
exports.getListProps = (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { isMulti: true, items: props.field.options }));
exports.getBoolComponentProps = (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { isMulti: false, items: utils_1.normalizeBooleanOptions(props.field.options), value: utils_1.getBooleanValue({
        value: props.value,
        defaultValue: props.field.default,
        shouldFallbackToDefault: !props.formProps.metadata.isOpened,
    }) }));
exports.getSingleLineStringProps = (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { choiceGroups: [], placeholder: 'Type value\u2026' }));
exports.getPasswordComponentProps = (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { placeholder: `Type value\u2026` }));
exports.getFileProps = (props) => (Object.assign({}, getPropsByField_1.default(props)));
const defaultOnChangeFieldValue = (_localFieldValue, setLocalFieldValue, newFieldValue, options) => {
    setLocalFieldValue(newFieldValue, options);
};
function getDefaultFieldProps(field) {
    return {
        hasFieldWrapper: true,
        isDisabled: Boolean(field.isDisabled),
        isErrored: field.isErrored,
        isRequired: field.required,
        label: utils_1.startCase(field.label),
    };
}
function onChangePrettySelectValue(_value, setLocalFieldValue, selected, options) {
    setLocalFieldValue(selected, options);
}
function onChangeFilterFieldValue(_value, setLocalFieldValue, selected, options) {
    setLocalFieldValue(selected, options);
}
const unicodeMapping = {
    component: MappableField_1.default,
    getFieldProps: getDefaultFieldProps,
    getComponentProps: getPropsByField_1.default,
    onChangeFieldValue: defaultOnChangeFieldValue,
};
const fieldComponentByType = {
    code: {
        component: Code_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: props => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { language: props.field.language })),
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    datetime: unicodeMapping,
    decimal: unicodeMapping,
    float: unicodeMapping,
    int: unicodeMapping,
    text: Object.assign(Object.assign({}, unicodeMapping), { getComponentProps: props => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { isMultiline: true })) }),
    password: {
        component: PasswordField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getPasswordComponentProps,
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    bool: {
        component: PrettySelect_1.PrettySelect,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getBoolComponentProps,
        onChangeFieldValue: onChangePrettySelectValue,
    },
    'pretty-select': {
        component: PrettySelect_1.PrettySelect,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getPrettySelectProps,
        onChangeFieldValue: onChangePrettySelectValue,
    },
    list: {
        component: ListField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getListProps,
        onChangeFieldValue: onChangePrettySelectValue,
    },
    copy: {
        component: CopyField_1.default,
        getFieldProps: (field) => (Object.assign(Object.assign({}, getDefaultFieldProps(field)), { hasFieldWrapper: false })),
        getComponentProps: getPropsByField_1.default,
    },
    'single-line-string': {
        component: MappableField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getSingleLineStringProps,
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    'copy-to-clipboard': {
        component: CopyToClipboardInput_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: props => {
            const placeholderMap = {
                'Feed URL': 'insert-custom-text-here',
            };
            const fieldLabel = props.field.label;
            const placeholder = placeholderMap[fieldLabel] || `Add ${fieldLabel} \u2026`;
            return Object.assign(Object.assign({}, getPropsByField_1.default(props)), { placeholder });
        },
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    unicode: unicodeMapping,
    file: {
        component: MappableField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: exports.getFileProps,
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    'convert-search': {
        component: CheckboxField_1.default,
        getFieldProps: (field) => (Object.assign(Object.assign({}, getDefaultFieldProps(field)), { hasFieldWrapper: false })),
        getComponentProps: (props) => ({
            description: props.field.description,
            isDisabled: getDefaultFieldProps(props.field).isDisabled,
            label: props.field.label,
            metadata: props.formProps.metadata,
            onChange: (newValue) => {
                props.formProps.onConvertSearch({ isWrite: newValue });
            },
            value: props.field.isChecked,
        }),
    },
    dict: {
        component: DictionaryField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: getPropsByField_1.default,
        onChangeFieldValue: (_value, setLocalFieldValue, newValue) => {
            setLocalFieldValue(newValue, { commit: true });
        },
    },
    fields: {
        component: Fields_1.default,
        getFieldProps: (field) => (Object.assign(Object.assign({}, getDefaultFieldProps(field)), { hasFieldWrapper: false })),
        getComponentProps: (props) => (Object.assign(Object.assign({}, getPropsByField_1.default(props)), { value: props.formValue, formProps: props.formProps })),
        onChangeFieldValue: () => { },
    },
    'static-hook-url': {
        component: design_system_1.CopyTextInput,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: (props) => ({
            disabledText: undefined,
            metadata: props.formProps.metadata,
            value: props.field.valueToCopy,
        }),
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    'silence-static-hook': {
        component: CheckboxField_1.default,
        getFieldProps: getDefaultFieldProps,
        getComponentProps: (props) => ({
            description: props.field.description,
            metadata: props.formProps.metadata,
            onChange: (newValue) => {
                props.formProps.onToggleSilenceHook({ isSilent: newValue });
            },
            value: props.field.isChecked,
        }),
        onChangeFieldValue: defaultOnChangeFieldValue,
    },
    filter: {
        component: FilterField_1.default,
        getFieldProps: (field) => (Object.assign(Object.assign({}, getDefaultFieldProps(field)), { hasFieldWrapper: false })),
        getComponentProps: (props) => (Object.assign({}, getPropsByField_1.default(props))),
        onChangeFieldValue: onChangeFilterFieldValue,
    },
};
function getFieldMapping(field) {
    const { type } = field;
    return fieldComponentByType[type] || fieldComponentByType.unicode;
}
exports.default = getFieldMapping;
function getFieldProps(field) {
    const fieldMapping = getFieldMapping(field);
    return fieldMapping.getFieldProps(field);
}
exports.getFieldProps = getFieldProps;
